import { render } from "./WorkoutExerciseGroup.vue?vue&type=template&id=3f16f0d6"
import script from "./WorkoutExerciseGroup.vue?vue&type=script&lang=js"
export * from "./WorkoutExerciseGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/farena/workspace/smt/smt_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__